import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'technical.title',
		'defaultMessage': 'Technical Specifications',
	},
	subtitle: {
		'id': 'technical.subtitle',
		'defaultMessage': 'Sheer quality of the fresh mint components makes it a premium product on the market.',
	},
	title1: {
		'id': 'technical.icon1.title',
		'defaultMessage': 'High-performance LED lights',
	},
	
	title2: {
		'id': 'technical.icon2.title',
		'defaultMessage': 'Silent exhaust and charcoal filter',
	},
	
	title3: {
		'id': 'technical.icon3.title',
		'defaultMessage': 'Silent low-maintenance ultrasound vaporizers',
	},
	
	title4: {
		'id': 'technical.icon4.title',
		'defaultMessage': 'Automated watering capable to feed on centralized water supply',
	},
	
	title5: {
		'id': 'technical.icon5.title',
		'defaultMessage': '4-component fertilizer mixing system',
	},
	title6: {
		'id': 'technical.icon6.title',
		'defaultMessage': 'Automated controls',
	},
	
	title7: {
		'id': 'technical.icon7.title',
		'defaultMessage': 'Advanced sensor array',
	},
	
});


// WEBPACK FOOTER //
// ./src/components/LandingTechSpecs/messages.js